import { client } from './client';
import interceptors from './interceptors';

client.interceptors.request.use(interceptors.noAuth, interceptors.onError);

function allProductCategory() {
    return client.get('/tunnel/api/public/product/data_category_product');
}

function allProductByCategoryId(params) {
    return client.get('/tunnel/api/public/product/data_product_by_category', {
        params: params
    });
}
export default {
    allProductCategory,
    allProductByCategoryId
};